import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import { get_payment_link } from "../Enums/api_constunts";
import "./TermsAndConditions.css"; // Custom CSS file for styles
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { set_password } from "../Enums/api_constunts";
import { postMethod } from "../Helpers/services";
import _ from "lodash";
import Checkbox from "../Components/Atoms/RadioButton/Checkbox";
import { domain } from "../axios";
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { PrimaryButton, CancelButton } from "../Components/Atoms/Button/Button";
import styles from "./CreateAccount/CreateAccount.module.scss";
import logo from "../Assests/Images/tfs_logo.png";

const PaymentWithTermsAndConditions = () => {
  const navigateTo = useNavigate();
  const [isSpinner, setIsSpinner] = useState(false);
  const location = useLocation();
  const [payment_details, setPaymentDetails] = useState(null);
  const get_payment_details = () => {
    setIsSpinner(true);
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const values = { token: token };
    postMethod(get_payment_link, values)
      .then((res) => {
        setIsSpinner(false);
        if (_.has(res, "result")) {
          setPaymentDetails(res["result"]);
        } else {
          showToast("error", "Something went wrong!");
        }
        //showToast("success",_.get(result, "message","Something went wrong!"))
        setIsSpinner(false);
      })
      .catch((error) => {
        showToast("error", _.get(error, "message", "Something went wrong!"));
        setIsSpinner(false);
      });
  };
  useEffect(() => {
    get_payment_details();
  }, []);

  const handlePayment = () => {
    const options = {
      key: "rzp_test_rAye2CW0Kqx4If", // Razorpay API Key
      amount: _.get(payment_details, "order_details.amount"), // Amount in paise (1 INR = 100 paise)
      currency: _.get(payment_details, "order_details.currency"),
      order_id: _.get(payment_details, "order_details.razorpay_order_id"),
      handler: function (response) {
        let post_data = {
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
        };

        postMethod(`${domain}auth/user-payment-success`, post_data)
          .then((result) => {
            navigateTo("/payment-success");
          })
          .catch((error) => {
            navigateTo("/payment-failure");
          });
      },
      prefill: {
        name: _.get(payment_details, "customer_details.name"),
        email: _.get(payment_details, "customer_details.email"),
        contact: _.get(payment_details, "customer_details.phone"),
      },
      notes: {
        address: "",
      },
      theme: {
        color: "#F37254",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
  const [openTermsCondations, setopenTermsCondations] = useState(0);
  const [acceptsTermsCondations, setacceptsTermsCondations] = useState(0);
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="">
      <div className="">

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            minHeight: "100vh",
            width: "100%",
            "@media (max-width: 768px)": {
              flexDirection: "column",
            },
          }}
        >
          {/* Left Section - Company Info */}
          <div
            style={{
              flex: "1",
              padding: "40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              "@media (max-width: 768px)": {
                padding: "20px",
                minHeight: "auto",
              },
            }}
          >
            <div
              style={{
                marginBottom: "30px",
                textAlign: "center",
              }}
            >
              {/* Replace with your company logo */}
              <img
                src={logo}
                alt="Company Logo"
                style={{
                  maxWidth: "200px",
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </div>
          </div>

          {/* Right Section - Payment Details */}
          <div
            style={{
              flex: "1",
              padding: "40px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "100%",
              backgroundColor: "#ffffff",
              overflowY: "auto",
              "@media (max-width: 768px)": {
                padding: "20px",
              },
            }}
          >
            <div
              style={{
                
              }}
            >
              <h1
                style={{
                  textAlign: "center",
                  marginBottom: "30px",
                  marginTop: "40",
                  color: "#333",
                  fontSize: "28px",
                }}
              >
                Payment
              </h1>

              <div
                style={{
                  marginBottom: "30px",
                }}
              >
                {_.get(payment_details, "plan_details.description") && (
                  <div style={{ marginBottom: "25px" }}>
                    <h5
                      style={{
                        color: "#333",
                        fontSize: "18px",
                        marginBottom: "15px",
                      }}
                    >
                      Plan Details
                    </h5>
                    <div
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "15px",
                        borderRadius: "8px",
                      }}
                    >
                      <ul
                        dangerouslySetInnerHTML={{
                          __html: _.get(
                            payment_details,
                            "plan_details.description"
                          ),
                        }}
                      />
                    </div>
                  </div>
                )}

                <div style={{ marginBottom: "25px" }}>
                  <h5
                    style={{
                      color: "#333",
                      fontSize: "18px",
                      marginBottom: "10px",
                    }}
                  >
                    1. Plan
                  </h5>
                  <p style={{ color: "#666" }}>
                    By subscribing to{" "}
                    {_.get(payment_details, "plan_details.name")}, you agree to
                    these terms...
                  </p>
                </div>

                <div style={{ marginBottom: "25px" }}>
                  <h5
                    style={{
                      color: "#333",
                      fontSize: "18px",
                      marginBottom: "10px",
                    }}
                  >
                    2. Amount
                  </h5>
                  <p
                    style={{
                      color: "#333",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    ₹{_.get(payment_details, "plan_details.amount")}/-
                  </p>
                </div>

                <div style={{ marginBottom: "25px" }}>
                  <h5
                    style={{
                      color: "#333",
                      fontSize: "18px",
                      marginBottom: "10px",
                    }}
                  >
                    3. Subscription Validity
                  </h5>
                  <p style={{ color: "#666" }}>
                    {_.get(payment_details, "plan_details.validity")} Days
                  </p>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                  backgroundColor: "#f8f9fa",
                  padding: "15px",
                  borderRadius: "8px",
                }}
              >
                <div style={{ flex: "1" }}>
                  <Checkbox
                    label="Accept Terms and Conditions"
                    style={{
                      width: "30px",
                      cursor: "pointer",
                    }}
                    id="tc"
                    name="tc"
                    options={[{ name: "Accept", value: false }]}
                    checked={acceptsTermsCondations == 1}
                    onChange={(v) => {
                      setacceptsTermsCondations(v ? 1 : 0);
                    }}
                  />
                </div>
                <div
                  onClick={() => setopenTermsCondations(1)}
                  style={{
                    cursor: "pointer",
                    color: "#0066cc",
                    marginLeft: "15px",
                  }}
                >
                  View
                </div>
              </div>

              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                }}
              >
                <PrimaryButton
                  onClick={handlePayment}
                  label="Pay Now"
                  style={{
                    padding: "12px 40px",
                    fontSize: "16px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: "#0066cc",
                    color: "white",
                    transition: "background-color 0.3s ease",
                    ":hover": {
                      backgroundColor: "#0052a3",
                    },
                    ":disabled": {
                      backgroundColor: "#cccccc",
                      cursor: "not-allowed",
                    },
                  }}
                  disabled={
                    acceptsTermsCondations == 0 ||
                    _.get(payment_details, "order_details.amount", "") == "" ||
                    _.get(payment_details, "order_details.currency", "") ==
                      "" ||
                    _.get(
                      payment_details,
                      "order_details.razorpay_order_id",
                      ""
                    ) == ""
                  }
                  spinner={isSpinner}
                />
              </div>
            </div>
          </div>
        </div>

        {openTermsCondations == 1 && (
          <>
            <Modal
              size="xl"
              show={openTermsCondations == 1}
              onHide={() => {
                setopenTermsCondations(0);
              }}
              centered
            >
              <Modal.Header closeButton>
                {" "}
                <Modal.Title>Terms And Conditions</Modal.Title>{" "}
              </Modal.Header>

              <Modal.Body>
                <Card className="shadow-lg border-0 rounded">
                  <Card.Body className="bg-white">
                    {/* <Card.Title className="text-center mb-4">
                  <h1>Terms and Conditions</h1>
                </Card.Title> */}

                    <div className="terms-content scrollable">
                      <h5 className="section-title">
                        1. Cancellation and Refunds
                      </h5>
                      <p>Subscriptions may not be cancelled...</p>

                      <h5 className="section-title">2. Data Privacy</h5>
                      <p>We value your privacy...</p>

                      <h5 className="section-title">3. Termination</h5>
                      <p>
                        We reserve the right to suspend or terminate your
                        access...
                      </p>

                      <h5 className="section-title">
                        4. Disclaimers and Limitation of Liability
                      </h5>
                      <p>The Service is provided "as is"...</p>

                      <h5 className="section-title">5. Governing Law</h5>
                      <p>
                        These Terms and Conditions are governed by the laws of
                        [Your Country/State]...
                      </p>

                      <h5 className="section-title">6. Changes to the Terms</h5>
                      <p>
                        We reserve the right to modify or update these Terms at
                        any time...
                      </p>

                      <h5 className="section-title">7. Contact Us</h5>
                      <p>
                        If you have any questions or concerns, please contact us
                        at [support email]...
                      </p>
                    </div>

                    <div className="row justify-content-end w-100">
                      <div
                        className="d-flex justify-content-end"
                        style={{ gap: "16px" }}
                      >
                        <CancelButton
                          label="Cancel"
                          onClick={() => setopenTermsCondations(0)}
                          className="btn btn-secondary"
                        />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Modal.Body>
            </Modal>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentWithTermsAndConditions;
